import { FC, useMemo, useState } from 'react';

import { useTranslation } from 'react-i18next';
import SVGIcon from 'react-inlinesvg';
import { useDispatch } from 'react-redux';
import { NavLink, useLocation } from 'react-router';

import Logo from '@assets/svg/logo.svg';
import { AppLink } from '@components';
import { setTheme, Theme } from '@store';
import { composeClassName, Routes, useDarkTheme } from '@utilities';

import styles from './index.module.scss';

export const Header: FC = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const isDarkTheme = useDarkTheme();
	const { pathname } = useLocation();
	const [open, setOpen] = useState(false);

	const menu = useMemo(
		() => [
			{
				text: t('Sources'),
				href: Routes.SOURCES
			},
			{
				text: t('Forwarders'),
				href: Routes.FORWARDERS
			},
			{
				text: t('Soboo'),
				href: Routes.SOBOO
			},
			{
				text: t('About'),
				href: Routes.ABOUT
			}
		],
		[t]
	);

	return (
		<header className={styles.header} data-testid="header">
			<div className={`shell ${styles.shell}`}>
				<AppLink type="internal" to={Routes.BASE} className={styles.logo} data-testid="logo">
					<SVGIcon src={Logo} />
				</AppLink>

				<nav className={composeClassName(styles.nav, open ? styles.navOpen : '')} data-testid="nav">
					<ul>
						{menu.map(item => (
							<li key={item.text}>
								<NavLink
									to={item.href}
									onClick={() => setOpen(false)}
									className={({ isActive }) => {
										const route = pathname.split('/').filter(Boolean)[0];

										if (isActive || item.href.includes(route)) {
											return styles.active;
										}

										return;
									}}
								>
									{item.text}
								</NavLink>
							</li>
						))}
					</ul>
				</nav>

				<button
					type="button"
					onClick={() => dispatch(setTheme(isDarkTheme ? Theme.LIGHT : Theme.DARK))}
					className={styles.theme}
					data-testid="theme-switcher"
				>
					<span className="sr-only">
						{t('Switch to {{mode}} theme', {
							mode: isDarkTheme ? 'light' : 'dark'
						})}
					</span>
				</button>

				<button
					type="button"
					onClick={() => setOpen(!open)}
					className={composeClassName(styles.burger, open ? styles.burgerOpen : '')}
				>
					<span></span>

					<span></span>

					<span></span>

					<small className="sr-only">{t('Toggle menu')}</small>
				</button>
			</div>
		</header>
	);
};

export default Header;
